<template>
  <div>
    <h2 class="bg-green-500 py-3 px-5 text-white mb-8">
      Step 2: Additional Information
    </h2>
    <h3>General Info</h3>
    <form @submit.prevent="goToNextPage">
      <d-field label="Drafting Experience">
        <d-input v-model="draftingExperience" type="textarea" aria-label="Drafting experience" required />
      </d-field>

      <h3 class="mb-1 pt-5">
        AWI Standards
      </h3>
      <d-field>
        <div>
          <div>
            <d-checkbox v-model="awiStandards" native-value="I currently own a copy of the AWI Architectural Woodwork Standards, 2nd Edition">
              I own a copy of the current AWI Standards
            </d-checkbox>
          </div>
          <div>
            <d-checkbox v-model="awiStandards" native-value="I am currently an active AWI Member">
              I am currently an active AWI Member
            </d-checkbox>
          </div>
          <div>
            <d-checkbox v-model="awiStandards" native-value="Please send me AWI Membership information">
              Please send me AWI Membership information
            </d-checkbox>
          </div>
        </div>
      </d-field>

      <h3 class="pt-5">
        Referral Info
      </h3>
      <d-field label="How did you hear about the QCP IDA program?">
        <d-select v-model="referralInfo" required expanded>
          <option value="" disabled>
            Please select an option
          </option>
          <option value="Article">
            Article
          </option>
          <option value="Ad">
            Ad
          </option>
          <option value="Seminar">
            Seminar
          </option>
          <option value="Member">
            Member
          </option>
          <option value="Architect">
            Architect
          </option>
          <option value="Other">
            Other (please specify)
          </option>
        </d-select>
      </d-field>
      <div v-if="referralInfo == 'Other'">
        <d-field label="If &quot;Other&quot;, please specify">
          <d-input v-model="otherReferred" aria-label="How did you learn about QCP" placeholder="Who referred you?" />
        </d-field>
      </div>
      <div class="flex flex-wrap justify-center md:justify-end pt-5">
        <d-btn class="mx-5" @click="goToPrevPage">
          Prev <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
        <d-btn type="submit" class="mx-5 md:mx-0">
          Next <span class="hidden sm:block sm:ml-1">Step</span>
        </d-btn>
      </div>
    </form>
  </div>
</template>

<script>
  import { createNamespacedHelpers } from 'vuex';
  import { mapFields } from '../../../../Resources/scripts/utilities/field.utilities';
  import { DRAFTING_ACCREDITION_FORM } from '../../../../Resources/scripts/store/mutation-types';

  const { mapActions } = createNamespacedHelpers('draftingAccreditionForm');

  export default {
    computed: {
      ...mapFields({
        fields: ['draftingExperience', 'awiStandards', 'referralInfo', 'otherReferred'],
        module: 'draftingAccreditionForm',
        base: 'formFields',
        mutation: DRAFTING_ACCREDITION_FORM.FORM_FIELDS,
      }),
    },

    methods: {
      ...mapActions([
        'goToPrevPage',
        'goToNextPage',
      ]),
    },
  };
</script>